import { render, staticRenderFns } from "./PublicDataLayout.vue?vue&type=template&id=1b8407c2&scoped=true&"
import script from "./PublicDataLayout.vue?vue&type=script&lang=js&"
export * from "./PublicDataLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8407c2",
  null
  
)

export default component.exports